<template>
  <div id="HomePage">
    <div class="text-left">
      <div style="position: relative;height:50px;" class="mb-2">
        <!-- <img class="user-poster" src="../assets/back-blue-white.png" style="height:110px;" /> -->
        <div class="title text-overflow">Hi, {{ RealName }}</div>
      </div>
      <!-- <van-row class="user-links mt-4 mb-2">
        <van-col span="12" class="color-gray">{{ getAuth().ToeknLastTime }}</van-col>
      </van-row>-->
      <van-cell-group class="user-group">
        <van-cell :title="'登录账号 :' + UserName">
          <template slot="icon">
            <i class="m-1 pr-1 fa fa-fw fa-id-card"></i>
          </template>
        </van-cell>
      </van-cell-group>
      <van-cell-group class="user-group">
        <van-cell icon="location-o" :title="'注册机构 :'+OrganName" />
      </van-cell-group>

      <van-cell-group class="user-group">
        <van-cell icon="records" :title="'个人信息 :'+UserInfoProgress" is-link to="/Setting" />
      </van-cell-group>

      <div class="mt-2" v-if="getWork()">
        <van-notice-bar
          color="#1989fa"
          mode="closeable"
          background="#ecf9ff"
          left-icon="info-o"
        >点击右上角图标,退出当前选择的考试</van-notice-bar>
      </div>
    </div>

    <!-- 推送消息 -->
    <div>
      <div @click="setH5PushMsg" hidden>测试推送消息</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "HomePage",
  data() {
    return {
      RealName: "用户姓名",
      UserName: "登陆账号",
      UserInfoProgress: 10,
      OrganName: "机构信息",
      WorkInfo: ""
    };
  },
  created() {
    //console.log(this.getAuth());
    this.apiUserGet(this, res => {
      //检测个人信息完善度
      if (res.data.RealName) this.UserInfoProgress += 10; //姓名
      if (res.data.UserIDCard) this.UserInfoProgress += 10; //身份证号
      if (res.data.Phone) this.UserInfoProgress += 10; //手机号
      if (res.data.OrganID) this.UserInfoProgress += 10; //所属单位
      if (res.data.Address) this.UserInfoProgress += 10; //地址信息
      if (res.data.OpeningBank) this.UserInfoProgress += 10; //开户银行
      if (res.data.BankNo) this.UserInfoProgress += 10; //银行卡号
      if (res.data.UrgentContact) this.UserInfoProgress += 10; //紧急联系人
      if (res.data.UrgentTel) this.UserInfoProgress += 10; //紧急联系电话
      this.UserInfoProgress =
        this.UserInfoProgress < 100
          ? "信息完善度:" + this.UserInfoProgress + "%"
          : "信息已完善";
      //个人信息项赋值
      this.RealName = res.data.RealName;
      this.UserName = res.data.UserName;
      this.OrganName = res.data.OrganName || "未认证所属机构";
      /* this.OrganID = e.OrganID 根据工作单位ID获取机构信息,显示单位或认证/未认证 */
      /* this.apiApiRemindersMsgGet({}, this, Element => {
        if (Element.Work) {
          this.WorkInfo = Element.Work[0];
        }
      }); */
    });
  },
  methods: {
    setH5PushMsg: function() {
      // H5 plus事件处理
      if (window.plus) {
        //在本地直接创建推送消息，并添加到系统消息中心。
        this.$toast("在本地直接创建推送消息，并添加到系统消息中心。");
        window.plus.push.createMessage("这是一条本地创建的推送消息内容");
      } else {
        this.$toast(
          "本地直接创建推送消息状态异常 (Error Code:401)."
        ); /* 错误代码401为随机数字,不代表其他意义,弹出错误提示的话说明当前运行环境不支持Html5Plus代码 */
      }
    },
    joinBtn(workid) {
      //进入考试
      this.apiWorkGetBy(
        {
          WorkID: workid
        },
        this,
        res => {
          // eslint-disable-next-line
          console.log(res);
          if (res.code == 20000) {
            this.setWork(res.data); //将用户登录考试后得信息存储
            this.setAddr(res.data.Organ.Range[0]); //将机构下第一个考点设为默认选项
            //定时跳转
            setTimeout(() => {
              this.$router.push(this.backUrl(res.data.User.RoleTypeID));
            }, 150);
          } else {
            this.$toast(res.message);
          }
        }
      );
    }
  }
};
</script>
<style scoped>
.user-poster {
  width: 100%;
  height: 53vw;
  display: block;
}
.user-group {
  margin-bottom: 15px;
}
.user-links {
  padding: 15px 0;
  font-size: 12px;
  text-align: center;
  background-color: #fff;
}
.van-icon {
  display: block;
  font-size: 24px;
}
.title {
  position: absolute;
  top: 1rem;
  width: 60%;
  left: 20%;
  text-align: center;
  color: rgb(218, 234, 255);
  font-size: 1.5rem;
  text-shadow: 5px 5px 5px #f1f1f1;
}
</style>
